// extracted by mini-css-extract-plugin
export default {"wrapper":"Q0-z","play":"R0-z"};